import {
  urlParameterService
} from '@/angularBridgeCode/ringbaPortal.servicesModule';
import {
  SET_PARAMETERS,
  SET_REFERENCES,
  ADD_URL_PARAM,
  REPLACE_URL_PARAM,
  SET_USER_VISIBLE_COLUMNS
} from './mutationTypes';
import {
  GET_PARAMETERS,
  CREATE_QUERY_PARAM,
  UPDATE_QUERY_PARAM,
  GET_REFERENCES,
  DELETE_PARAMETER,
  GET_USER_VISIBLE_COLUMNS,
} from './actionTypes';

import {
  SET_ACTION_STATUS_PENDING,
  SET_ACTION_STATUS_SUCCESS,
  SET_ACTION_STATUS_ERROR } from '@/store/helpers';

const actions = {
  async [GET_PARAMETERS]({ rootState, commit }) {
    commit(SET_ACTION_STATUS_PENDING, { actionName: GET_PARAMETERS });      
    commit(SET_PARAMETERS, []);
    try {      
      var parameters = await urlParameterService.getUrlParameters(rootState.currentAccountId);
      commit(SET_PARAMETERS, parameters.data.queryPathMaps);
      commit(SET_ACTION_STATUS_SUCCESS, { actionName: GET_PARAMETERS });
    } catch (e) {
      commit(SET_ACTION_STATUS_ERROR, { actionName: GET_PARAMETERS, error: e });
    }
  },
  async [CREATE_QUERY_PARAM]({ rootState, commit }, queryPathMap) {
    commit(SET_ACTION_STATUS_PENDING, { actionName: CREATE_QUERY_PARAM });
    try {
      const response = await urlParameterService.createUrlParameter(rootState.currentAccountId, queryPathMap);
      commit(ADD_URL_PARAM, response.data.queryPathMap);
      commit(SET_ACTION_STATUS_SUCCESS, { actionName: CREATE_QUERY_PARAM });
    } catch (e) {
      commit(SET_ACTION_STATUS_ERROR, { actionName: CREATE_QUERY_PARAM, error: e });
    }
  },
  async [UPDATE_QUERY_PARAM]({ rootState, commit }, queryPathMap) {
    commit(SET_ACTION_STATUS_PENDING, { actionName: UPDATE_QUERY_PARAM });
    try {
      const response = await urlParameterService.updateUrlParameter(rootState.currentAccountId, queryPathMap);
      commit(REPLACE_URL_PARAM, response.data.queryPathMap);
      commit(SET_ACTION_STATUS_SUCCESS, { actionName: UPDATE_QUERY_PARAM });
    } catch (e) {
      commit(SET_ACTION_STATUS_ERROR, { actionName: UPDATE_QUERY_PARAM, error: e });
    }
  },
  async [GET_REFERENCES]({ rootState, commit }, queryPathMapId) {
    commit(SET_ACTION_STATUS_PENDING, { actionName: GET_REFERENCES });
    try {
      var response = await urlParameterService.getUrlParameterReferences(rootState.currentAccountId, queryPathMapId);
      commit(SET_REFERENCES, response.data);
      commit(SET_ACTION_STATUS_SUCCESS, { actionName: GET_REFERENCES });
    } catch (e) {
      commit(SET_ACTION_STATUS_ERROR, { actionName: GET_REFERENCES, error: e });
    }
  },
  async [DELETE_PARAMETER]({ rootState, commit, dispatch }, queryPathMapId) {
    commit(SET_ACTION_STATUS_PENDING, { actionName: DELETE_PARAMETER });
    try {
      await urlParameterService.deleteUrlParameter(rootState.currentAccountId, queryPathMapId, true);
      commit(SET_ACTION_STATUS_SUCCESS, { actionName: DELETE_PARAMETER });
      dispatch('getParameters');
    } catch (e) {
      commit(SET_ACTION_STATUS_ERROR, { actionName: DELETE_PARAMETER, error: e });
    }
  },
  async [GET_USER_VISIBLE_COLUMNS]({ commit }) {
    commit(SET_ACTION_STATUS_PENDING, { actionName: GET_USER_VISIBLE_COLUMNS });
    commit(SET_USER_VISIBLE_COLUMNS, []);
    try {
      var userVisibleColumns = _.map(_.filter(urlParameterService.columnSettings, (col) => !col.hide), (col) => {
        return col.name;
      });
      commit(SET_USER_VISIBLE_COLUMNS, userVisibleColumns);
      commit(SET_ACTION_STATUS_SUCCESS, { actionName: GET_USER_VISIBLE_COLUMNS });
    } catch (e) {
      commit(SET_ACTION_STATUS_ERROR, { actionName: GET_USER_VISIBLE_COLUMNS, error: e });
    }
  },
};

export default actions;